import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import { GET_POC_BY_ID } from "./type";

export const addPoc = (pocData) => async () => {
  const res = await callWebService(
    callTypes.post,
    pocData,
    Config.brandActivation.sitePocAdd
  );
  if (res) {
    const { data } = res.data.response;
    if (data) return data;
  } else {
    return null;
  }
};

export const editPoc = (pocData) => async () => {
  const res = await callWebService(
    callTypes.put,
    pocData,
    Config.brandActivation.sitePocUpdate
  );
  if (res) {
    const { status } = res.data.response;
    if (status) return true;
  } else {
    return false;
  }
};

export const getPocById = (pocId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.poc.getPocById}?poc_id=${pocId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_POC_BY_ID, payload: data.response.data });
    return data;
  } else {
    return null;
  }
};
